import { render, staticRenderFns } from "./AddAccountGroup.vue?vue&type=template&id=34aa5c93"
import script from "./AddAccountGroup.vue?vue&type=script&lang=js"
export * from "./AddAccountGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports